<script setup>
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
import {defineProps} from "vue";

const props = defineProps({
    authView: {
        type: Boolean,
        default: false
    }
});

const portalContentAndDesignStore =  usePortalContentAndDesignStore()
</script>

<template>
    <radio-group-inline
        label="Navigation background"
        name="portal_layout_navigation_color"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_navigation_color"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_navigation_color = $event"
        :options="[
            { value: 'brand', label: 'Brand'},
            { value: 'white', label: 'White'},
            { value: 'gray', label: 'Gray'},
            { value: 'black', label: 'Black'},
        ]">
    </radio-group-inline>

    <radio-group-inline
        label="Navigation style"
        name="portal_layout_navigation_links"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_navigation_links"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_navigation_links = $event"
        :options="[
        { value: 'links', label: 'Links'},
        { value: 'pills', label: 'Pills'},
        { value: 'border', label: 'Border'},
    ]">
    </radio-group-inline>

    <radio-group-inline
        label="Icons"
        name="portal_layout_icons"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_icons"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_icons = $event"
        :options="[
            { value: 'outline', label: 'Outline'},
            { value: 'bold', label: 'Bold'},
            { value: 'off', label: 'None'},
        ]"
    >
    </radio-group-inline>

    <radio-group-inline
        label="Logo size"
        name="portal_layout_logo_size"
        :model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_logo_size"
        @update:model-value="portalContentAndDesignStore.portalLayoutSettings.portal_layout_logo_size = $event"
        :options="[
            { value: 'max-h-4', label: 'Small'},
            { value: 'max-h-6', label: 'Default'},
            { value: 'max-h-8', label: 'Medium'},
            { value: 'max-h-10', label: 'Large'},
        ]"
    >
    </radio-group-inline>
</template>

